const columns = [
  { name: "Nome do aluno", value: "userName", filter: true },
  { name: "Média", value: "averageQuiz", filter: false },
  { name: "Reprov. em quiz", value: "failedQuizzes", filter: false },
  { name: "Último acesso", value: "lastAccess", filter: false },
  { name: "Status do aluno", value: "studentStatus", filter: false },
  // { name: "Status do curso", value: "courseStudentStatus", filter: false },
  { name: "Turma", value: "classroomName", filter: false },
];

export { columns };
